import { useContractContext } from "@/contexts/ContractContext";
import { useFluxPayContractContext } from "@/contexts/FluxPayContractContext";
import { isFreePlanContract } from "@/utils/contract";

/**
 * Plano gratuito + Flux Pay (marketplace): após enviar cobrança o modal não deve fechar
 * até o usuário confirmar o pagamento.
 */
export function useKeepPaymentModalOpenAfterCharge(): boolean {
  const { currentContract } = useContractContext();
  const { contractFluxPay } = useFluxPayContractContext();
  const resource = currentContract?.[0]?.resource;
  return isFreePlanContract(resource) && Boolean(contractFluxPay);
}
